__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "samurai_hub_roadmap";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.10.5", () => (Promise.all([__webpack_require__.e(403), __webpack_require__.e(15), __webpack_require__.e(291), __webpack_require__.e(462)]).then(() => (() => (__webpack_require__(8015))))));
			register("@emotion/styled", "11.10.5", () => (Promise.all([__webpack_require__.e(995), __webpack_require__.e(291), __webpack_require__.e(882), __webpack_require__.e(81)]).then(() => (() => (__webpack_require__(5995))))));
			register("@it-incubator/ui-kit", "1.0.8", () => (Promise.all([__webpack_require__.e(467), __webpack_require__.e(52), __webpack_require__.e(291), __webpack_require__.e(325), __webpack_require__.e(209), __webpack_require__.e(364), __webpack_require__.e(301)]).then(() => (() => (__webpack_require__(4052))))));
			register("@mui/material", "5.11.5", () => (Promise.all([__webpack_require__.e(467), __webpack_require__.e(403), __webpack_require__.e(304), __webpack_require__.e(325), __webpack_require__.e(882), __webpack_require__.e(526), __webpack_require__.e(682)]).then(() => (() => (__webpack_require__(8304))))));
			register("@reduxjs/toolkit", "1.9.7", () => (__webpack_require__.e(389).then(() => (() => (__webpack_require__(7389))))));
			register("@tanstack/react-query", "5.8.1", () => (Promise.all([__webpack_require__.e(368), __webpack_require__.e(58)]).then(() => (() => (__webpack_require__(4368))))));
			register("axios", "1.6.7", () => (__webpack_require__.e(677).then(() => (() => (__webpack_require__(4677))))));
			register("framer-motion", "12.10.4", () => (Promise.all([__webpack_require__.e(512), __webpack_require__.e(325), __webpack_require__.e(972), __webpack_require__.e(63)]).then(() => (() => (__webpack_require__(8512))))));
			register("html-react-parser", "5.1.8", () => (Promise.all([__webpack_require__.e(492), __webpack_require__.e(20)]).then(() => (() => (__webpack_require__(3492))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(370), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(2370))))));
			register("react-helmet", "6.1.0", () => (Promise.all([__webpack_require__.e(602), __webpack_require__.e(133)]).then(() => (() => (__webpack_require__(1602))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(327), __webpack_require__.e(209)]).then(() => (() => (__webpack_require__(9327))))));
			register("react-router-dom", "6.18.0", () => (Promise.all([__webpack_require__.e(430), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(2049))))));
			register("react-toastify", "9.1.3", () => (Promise.all([__webpack_require__.e(833), __webpack_require__.e(515)]).then(() => (() => (__webpack_require__(6833))))));
			register("react", "18.2.0", () => (__webpack_require__.e(121).then(() => (() => (__webpack_require__(4121))))));
			register("zod", "3.22.4", () => (__webpack_require__.e(597).then(() => (() => (__webpack_require__(8597))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};